import Icon from "@common/controls/Icon/component";
import { IconType } from "@common/declarations";
import { useI18n } from "@common/hooks/i18n";
import Network from "@common/modules/network/types";
import classNames from "classnames";
import React from "react";
import { formatRewardTitle } from "./lib";

type RewardTitleProps = {
  index: number;
  reward: Network.Incentives.Reward;
};
export const RewardTitle = (props: RewardTitleProps) => {
  const i18n = useI18n();

  return (
    <span>
      <Icon icon={IconType.Medal} className={classNames(`prize n${props.index + 1}`)} />
      {formatRewardTitle(i18n, props.reward, props.index)}
    </span>
  );
};
